import Vue from 'vue';
import Vuex from 'vuex';
import { isDevelopment } from '@mockup/func/globals/environment';

Vue.use(Vuex);

const store = new Vuex.Store({
    strict: isDevelopment,
    namespaced: true,
    state: {
        urls: {}
    },
    mutations: {
        internal_url(state, data) {
            state.urls = Object.assign(state.urls, data);
        }
    },
    actions: {
        setUrl({commit}, data) {
            commit('internal_url', JSON.parse(data));
        }
    }
});

export default store;
